export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-hi5-216c804e3f6f051b1ff405ba6c0ac4a3.svg";